<template>
  <div>
    <h3>
      <span class="header-text">Translational Team - {{ translationalTeam.name }}</span>
      <b-button class="btn-primary pull-right" :to="{ name: 'translationalTeamEdit', params: {translationalTeamId: translationalTeamId}}">Edit</b-button>
    </h3>

    <widget>
      <team-details :translationalTeam="translationalTeam"/>
    </widget>
    
    <widget heading="Description">
      <show-more :text="translationalTeam.description" v-if="translationalTeam && translationalTeam.description"></show-more>
    </widget>

    <widget heading="Sites">
      <team-sites :sites="sites"></team-sites>
    </widget>

    <widget heading="Opportunities" v-if="translationalTeam.opportunities">
      <team-opportunities :opportunities="translationalTeam.opportunities"></team-opportunities>
    </widget>

    <widget heading="People">
      <team-people :translationalTeam="translationalTeam"></team-people>
    </widget>
    
  </div>
</template>

<script>
import TeamDetails from "../../components/translationalteams/team-details";
import TeamSites from "../../components/translationalteams/team-sites";
import TeamOpportunities from "../../components/translationalteams/team-opportunities";
import TeamPeople from "../../components/translationalteams/team-people";
import Widget from "../../components/widget";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import ShowMore from "../../components/show-more";

export default {
  data() {
    return {};
  },

  props: {
    translationalTeamId: {
      required: true
    }
  },

  components: {
    "team-details": TeamDetails,
    "team-sites": TeamSites,
    "team-opportunities": TeamOpportunities,
    "team-people": TeamPeople,
    widget: Widget,
    "show-more": ShowMore
  },

  computed: {
    sites: function() {
      return _.map(this.translationalTeam.translationalTeamSites, function(
        translationalTeamSite
      ) {
        return translationalTeamSite.site;
      });
    },

    translationalTeam: function() {
      return this.$store.state.translationalTeam.translationalTeam;
    }
  },

  created() {
    this.$store.dispatch(
      "translationalTeam/getTranslationalTeam",
      this.translationalTeamId
    );
  }
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}

.widget-body {
  font-size: 13px;
}

.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}
</style>
